export function BarChart({
  data,
  min = 0,
  ariaLabel,
  formatValue,
}: {
  data: { label: string; value: number; bonus?: number }[];
  min?: number;
  ariaLabel: string;
  formatValue?: (v: number) => string;
}) {
  const fmt = formatValue ?? ((v: number) => `$${(v / 1000).toFixed(1)}k`);
  const max = Math.max(...data.map((d) => d.value + (d.bonus ?? 0)), min + 1);
  const range = Math.max(max - min, 1);

  const curvePoints = data.map((d, i) => ({
    x: data.length === 1 ? 50 : (i / (data.length - 1)) * 100,
    y: 100 - Math.max(((d.value + (d.bonus ?? 0) - min) / range) * 100, 4),
  }));
  let curvePath = `M ${curvePoints[0].x},${curvePoints[0].y}`;
  for (let i = 1; i < curvePoints.length; i++) {
    const cpx = (curvePoints[i - 1].x + curvePoints[i].x) / 2;
    curvePath += ` C ${cpx},${curvePoints[i - 1].y} ${cpx},${curvePoints[i].y} ${curvePoints[i].x},${curvePoints[i].y}`;
  }
  curvePath += " L 100,100 L 0,100 Z";

  return (
    <div
      className="relative flex h-48 justify-between gap-16 overflow-visible"
      aria-label={ariaLabel}
    >
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        className="pointer-events-none absolute inset-0 h-full w-full"
      >
        <path d={curvePath} fill="#EEF7FC" />
      </svg>
      {data.map((d, i) => {
        const isHighlighted = i === data.length - 1 || !!d.bonus;
        const regularPct = Math.max(((d.value - min) / range) * 100, 4);
        const bonusPct = d.bonus ? (d.bonus / range) * 100 : 0;
        const totalDisplay = d.value + (d.bonus ?? 0);
        return (
          <div
            key={`${d.label}-${i}`}
            className="relative flex h-full flex-1 flex-col items-center justify-end gap-1"
          >
            <div className="flex w-full flex-1 flex-col justify-end">
              <span className=" text-center text-[0.5rem] font-semibold text-text-primary">
                {fmt(totalDisplay)}
              </span>
              {d.bonus && (
                <div
                  className="w-full min-h-1 rounded-none bg-[#1FC16B]"
                  style={{
                    height: `${bonusPct}%`,
                  }}
                  title={`Bono: ${fmt(d.bonus)}`}
                />
              )}
              <div
                className=" min-h-1 w-full rounded-none transition-opacity duration-150 hover:opacity-80"
                style={{
                  height: `${regularPct}%`,
                  background: isHighlighted ? "#0066AA" : "#535353",
                }}
                title={`${d.label}: ${fmt(d.value)}`}
              />
            </div>
            <span
              className="
                absolute -bottom-[1.1rem] whitespace-nowrap text-[0.625rem]
                font-medium uppercase tracking-[0.04em] text-text-muted
              "
            >
              {d.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
